<template>
    <div class="mt-10">
        <h1 class="text-center mt-10">Help Center</h1>

        <v-container class="mt-10">
            <v-row justify="center">
                <v-col cols="12" md="6">
                    <v-toolbar color="#365136" flat>
                        <v-spacer></v-spacer>
                        <v-toolbar-title class="white--text text-center">Support Information</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="custom-title">
                                <div>
                                    <v-icon class="mr-4" color="#365136">mdi-login</v-icon>
                                    Login & Access
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-container>
                                        To access the Workdesk App:
                                        <ul class="mx-10">
                                            <li>Enter your email or username and password</li>
                                            <li>Tap "Login" </li>
                                        </ul>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class="custom-title">
                                <div>
                                    <v-icon class="mr-4" color="#365136">mdi-clock-time-five-outline</v-icon>
                                    Clock In / Clock Out
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-container>
                                    To log your working hours:
                                    <ol class="mx-10">
                                        <li>Tap "Find My Location" to update your exact GPS location.</li>
                                        <li>Once located, tap "Time In."</li>
                                        <li>At the end of your work period, tap "Time Out."</li>
                                    </ol>
                                    Your location will be recorded with each action.
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class="custom-title">
                                <div>
                                        <v-icon class="mr-4" color="#365136">mdi-map-marker-outline</v-icon>
                                        Location Tracking
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-container>
                                    The app uses your device's location to log accurate entries:
                                    <ul class="mx-10">
                                        <li>Ensure Location Services are enabled.</li>
                                        <li>Allow Workdesk App to access location "While Using the App."</li>
                                        <li>Workdesk only tracks location during Time In/Out actions, not continuously.</li>
                                    </ul>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class="custom-title">
                                <div>
                                    <v-icon class="mr-4" color="#365136">mdi-list-box-outline</v-icon>
                                    Daily Time Record (DTR)
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                            <v-container>
                                    All your time logs are stored in the DTR section:
                                    <ul class="mx-10">
                                        <li>Open the hamburger menu ([menu])</li>
                                        <li>Tap "DTR" to view all Time In/Out records</li>
                                        <li>Each record includes the time, date, and location</li>
                                    </ul>
                            </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class="custom-title">
                                <div>
                                    <v-icon class="mr-4" color="#365136">mdi-wifi</v-icon>
                                    Internet Requirements
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-container>
                                    The Workdesk App requires a stable internet connection to:
                                    <ul class="mx-10">
                                        <li>Clock in/out</li>
                                        <li>View DTR</li>
                                    </ul>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header class="custom-title">
                                <div>
                                        <v-icon class="mr-4" color="#365136">mdi-wrench-cog-outline</v-icon>
                                        Troubleshooting Tips
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-container>
                                    If you're having issues: 
                                    <ul class="mx-10">
                                        <li>Check that location is enabled and permissions are granted.</li>
                                        <li>Verify your internet connection is stable.</li>
                                        <li>Try restarting the app or your phone.</li>
                                        <li>Clear cache or reinstall the app if needed.</li>
                                    </ul>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container class="mt-10">
           <v-row justify="center">
                <v-col cols="12" md="6">
                    <v-toolbar color="#365136" flat>
                        <v-spacer></v-spacer>
                        <v-toolbar-title class="white--text text-center">Frequently Asked Questions (FAQ)</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card class="my-5 pa-4">
                        <v-card-title>
                            How can I log in to the Workdesk App? 
                        </v-card-title>
                        <v-card-text>
                            You can log in using your email or username and your password.
                        </v-card-text>
                    </v-card>

                    <v-card class="my-5 pa-4">
                        <v-card-title>
                            Does the Workdesk App work without internet access?
                        </v-card-title>
                        <v-card-text>
                            No. The app requires internet access to function correctly.
                        </v-card-text>
                    </v-card>

                    <v-card class="my-5 pa-4">
                        <v-card-title>
                            How can I Clock In and Clock Out?
                        </v-card-title>
                        <v-card-text>
                            <ol class="mx-5">
                                <li>Tap "Find My Location" to detect your GPS location.</li>
                                <li>Tap "Time In."</li>
                                <li>Tap "Time Out" when you're done.</li>
                            </ol>
                        </v-card-text>
                    </v-card>

                    <v-card class="my-5 pa-4">
                        <v-card-title>
                            Can I view my Clock In and Clock Out history?
                        </v-card-title>
                        <v-card-text>
                            Yes. Open the hamburger menu ([menu]) and tap "DTR." All your previous logs are listed there.
                        </v-card-text>
                    </v-card>

                    <v-card class="my-5 pa-4">
                        <v-card-title>
                            Do I need to allow the app to access my phone's location?
                        </v-card-title>
                        <v-card-text>
                            Yes. You must enable location access so the app can accurately log your location during time entries.
                        </v-card-text>
                    </v-card>
                    
                </v-col>
           </v-row>
        </v-container>

        <FooterPage/>
    </div>
</template>

<script>
import FooterPage from '@/components/FooterPage.vue';

export default {
    name: "HelpCenter",
    components: {
        FooterPage
    }
}
</script>

<style scoped>
.custom-title {
  color: #365136;
  font-weight: bold;
}

.v-icon {
    font-size: 40px;
}
</style>
